import KogCheckBoxControlled from "@/main/components/shared/checkbox/checkBoxControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";

interface IBackOrderCheckboxProps {
	fieldPrefix: string;
	showFieldWithouEdit?: boolean;
	row?: QuoteSupplierItemPartResponse;
}

export default function ColumnBackOrder({ fieldPrefix, showFieldWithouEdit, row }: IBackOrderCheckboxProps) {
	const { control } = useFormContext();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote`,
		defaultValue: false,
	});

	const idElementCreateAnswerBackOrder =
		row && row.partTypeName
			? `id-createAnswer-checkBox-backOrder-${row.partTypeName}`
			: "id-createAnswer-checkBox-backOrder";

	return (
		<KogCheckBoxControlled
			id={idElementCreateAnswerBackOrder}
			label=""
			nameCustom={`${fieldPrefix}.backOrder`}
			control={control}
			disabled={showFieldWithouEdit || watcherNotQuote}
		/>
	);
}
